<template>
    <b-modal
        id="terms-conditions-privacy-policy"
        size="lg"
        centered
        title-class="d-flex align-items-center"
        content-class="border-0"
        footer-class="justify-content-center"
        @show="userAgrees = isAlreadyAgreed"
        @hide="handleCloseModal">
        <template #modal-title>
            <img src="@/assets/images/rush-logo-new.svg" alt="RUSH" class="modal-logo mr-3">
            <h3 class="mb-0">Terms &amp; Conditions and Privacy Policy</h3>
        </template>
        <template #modal-header-close>
            <img src="@/assets/images/close-icon.svg" alt="Close">
        </template>
        <div id="content-container" class="p-3">
            <SubscriptionAgreementContent :code='code' />
            <b-form>
                <b-form-group class="text-center font-weight-bold">
                    <b-form-checkbox v-model="userAgrees">I have read the Terms & Conditions and Privacy Policy</b-form-checkbox>
                </b-form-group>
            </b-form>
        </div>
        <template #modal-footer>
            <b-button
                variant="primary"
                pill class="px-5 border-0"
                :disabled="!userAgrees"
                @click="handleUserAgreed">
                Proceed
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import SubscriptionAgreementContent from './SubscriptionAgreementContent';

export default {
    name: "TermsConditionsAndPrivacyPolicyModal",
    props: {
      code: {
        type: String
      },
      isAlreadyAgreed: {
        type: Boolean,
        default: false
      }
    },
    components: { SubscriptionAgreementContent },
    data() {
        return {
            userAgrees: false,
        }
    },
    methods: {
        handleCloseModal() {
            if (!this.userAgrees) this.$emit("userAgreedToTermsConditionsPrivacyPolicy", this.userAgrees);
        },
        handleUserAgreed() {
            this.$emit("userAgreedToTermsConditionsPrivacyPolicy", this.userAgrees);
            this.$nextTick(() => {
                this.$bvModal.hide("terms-conditions-privacy-policy");
            });
        }
    }
}
</script>

<style lang="scss">
#terms-conditions-privacy-policy {
    .modal-logo {
        max-width: 77px;
        filter: grayscale(1);
    }
    .modal-title {
        h3 {
            font-size: 22px;
            color: #2F3941;
        }
    }
    .close {
        outline: 0;
    }
    #content-container {
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 7px;
            height: 7px;
        }
        &::-webkit-scrollbar-thumb {
            background: #dde7ed;
            border-radius: 4px;
        }
        p {
            font-size: 14px;
            line-height: 26px;
            color: #87929D;
        }
    }
    .btn.btn-primary.disabled {
        background: #E9EBED;
        color: #87929D;
        border: 0;
    }
    .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #FF830E;
        background-color: #FF830E;
    }
}
</style>